// 引入公共 store 配置（来自 channel_app.js）
// store 和 Vuex 变量已通过 CDN 在 public/index.html 中全局定义

// 扩展 mutations，覆盖 changeKeys 以适配本项目
const customMutations = {
    // 改变文章关键词/ID后初始化文章数组 - 本项目首次加载25篇
    changeKeys(state, keys) {
        state.keys = keys
        state.size = 17  // 设置为15，加上 addText 的10，首次获取25篇
        state.text = []
    }
}

// 合并自定义 mutations 到全局 store
if (store && store.mutations) {
    Object.assign(store.mutations, customMutations)
}

export default new Vuex.Store(store)
